var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldEmblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5894,
    cy: 23.824,
    r: 23.0024,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0934 35.8889C27.5807 34.7479 33.4476 31.2236 33.4476 23.3626V18.6134C33.4476 17.2755 33.4476 16.6055 33.1904 16.094C32.964 15.6436 32.6017 15.2777 32.1573 15.0482C31.6521 14.7873 30.9916 14.7873 29.6689 14.7873H18.3319C17.0092 14.7873 16.3473 14.7873 15.8421 15.0482C15.3977 15.2777 15.0366 15.6436 14.8102 16.094C14.5527 16.606 14.5527 17.2768 14.5527 18.6173V23.3626C14.5527 31.2236 20.4194 34.7479 22.9066 35.8889C23.1702 36.0099 23.3027 36.0702 23.6012 36.1221C23.7894 36.1549 24.2121 36.1549 24.4003 36.1221C24.6978 36.0704 24.8289 36.0103 25.0907 35.8901L25.0934 35.8889Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldEmblem);
export default __webpack_public_path__ + "static/media/ShieldEmblem.6d48f51d97b3acd1517791f0a5c2228a.svg";
export { ForwardRef as ReactComponent };